const oneLinks = {
  webSitePage: "https://joinparachute.onelink.me/zGML/d6e57caa",
  webSiteFooter: "https://joinparachute.onelink.me/zGML/ebd9ec4e",
  referralPage: "https://joinparachute.onelink.me/zGML/17cf96de",
  donorQuizSuccessHero: "https://joinparachute.onelink.me/zGML/nga2wend",
  donorQuizGasGuarantee: "https://joinparachute.onelink.me/zGML/1ev87o6h",
}

export type OneLinkHref = keyof typeof oneLinks

export default oneLinks
